import { selectDoesUserHaveRbacPermission } from 'core/userContext/selectors';
import {
  CampaignDetailProps,
  CampaignHeaderDetails,
} from 'modules/campaigns/lib/components/CampaignHeaderDetails';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import { TAG_SIZES, TagGroup } from 'ui/tags';
import noop from 'utils/noop';
import { PROJECT_PERMISSIONS } from 'utils/permissions';
import { getUrlParams } from 'utils/urlParams';
import { updateCampaignLabelsRequest } from '../actions';
import { selectProjectId } from '../selectors';
import { Label } from '../types';
import { filterLabels } from '../utils';

export type PageSubsectionProps = {
  labels: Label[];
  suggestedLabels: Label[];
  refetch: () => any;
  destinations?: { name: string; platform: string }[];
  campaignDetails: CampaignDetailProps;
  onViewAlerts?: () => void;
  hasRecentTriggeredAlerts: boolean;
};

export const PageSubsection = ({
  hasRecentTriggeredAlerts,
  labels = [],
  suggestedLabels = [],
  refetch,
  campaignDetails,
  onViewAlerts = noop,
}: PageSubsectionProps) => {
  const { search } = useLocation();
  const dispatch = useDispatch();
  const { campaignId } = getUrlParams(search);

  const canEditLabels = useSelector((state: any) =>
    selectDoesUserHaveRbacPermission(state)(PROJECT_PERMISSIONS.DraftMessaging),
  );

  const projectId = useSelector(selectProjectId);
  const selectedLabelTags = labels.map((el) => el.name);
  const selectedLabelSet = new Set(selectedLabelTags);
  const labelTags = suggestedLabels.map((el) => el.name).filter((el) => !selectedLabelSet.has(el));
  const updateLabels = (updatedLabels: string[]) => {
    const filteredLabels = filterLabels(updatedLabels, suggestedLabels, projectId);
    dispatch(
      updateCampaignLabelsRequest({
        campaignId,
        labels: filteredLabels,
        callback: refetch,
      }),
    );
  };

  return (
    <>
      {campaignDetails && (
        <CampaignHeaderDetails
          campaignDetails={campaignDetails}
          hasRecentTriggeredAlerts={hasRecentTriggeredAlerts}
          onViewAlerts={onViewAlerts}
        >
          <>
            {selectedLabelTags && (
              <TagGroup
                value={selectedLabelTags}
                tags={labelTags}
                isEditable={canEditLabels}
                onUpdate={canEditLabels ? updateLabels : () => null}
                tagSize={TAG_SIZES.LARGE}
                maxTags={2}
              />
            )}
          </>
        </CampaignHeaderDetails>
      )}
    </>
  );
};
